import React from "react"
import ClubCleanTableRecordSearch from "./component/ClubCleanTableRecordSearch";
import ClubCleanTableRecordTable from "./component/ClubCleanTableRecordTable";

const ClubCleanTableRecordLayout = () => {

    return <div>
        <div style={{display: "flex", flexDirection: "column", gap: 20}}>
            <ClubCleanTableRecordSearch></ClubCleanTableRecordSearch>
            <ClubCleanTableRecordTable></ClubCleanTableRecordTable>
        </div>
    </div>
}


export default ClubCleanTableRecordLayout


// WEBPACK FOOTER //
// ./src/containers/ClubCleanTableRecord/layout.js